var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      ref: "objectForm",
      staticClass: "home-form-container elevation-2",
      style: { right: _vm.sidebarIsOpen ? 300 - 95 + "px" : "0" },
      attrs: { column: "" }
    },
    [
      _c("object-form-header", {
        attrs: {
          title: _vm.title,
          "sub-title": _vm.subTitle,
          layer: _vm.layer
        },
        on: {
          close: function($event) {
            return _vm.$emit("close")
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { height: "84%", overflow: "auto" } },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.objectUuid && _vm.layer
        ? _c("object-form-footer", {
            staticClass: "mx-15 mb-3 object-form-footer",
            attrs: {
              layer: _vm.layer,
              "object-uuid": _vm.objectUuid,
              "object-coordinate": _vm.objectCoordinates
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6fdbd928", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fdbd928","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/Forms/_Templates/ObjectFormStructure.vue
// module id = null
// module chunks = 